import React from "react";
import { Card } from "primereact/card";

import FieldInputMask from "../common/FieldInputMask";
import FieldInputText from "../common/FieldInputText";
import FieldInputTextarea from "../common/FieldInputTextarea";
import FieldCheckbox from "../common/FieldCheckbox";

import "../../css/lobbyist-details.css";

class CompanyDetails extends React.Component {
  render() {
    const {
      isAdd,
      canSave,
      showAsTextOnly,
      validationRules,
      isAuthenticated,
      formName,
    } = this.props;
    return (
      <Card title="People Undertaking Lobbyist Activities or Directors">
        <div className="p-grid">
          {isAdd === false && isAuthenticated === true && (
            <div className="p-col-12">
              <FieldInputText
                field={"StatusDescription"}
                label={"Status"}
                showAsTextOnly={true}
              />
            </div>
          )}
          <div className="p-col-12">
            <FieldInputText
              field={"BusinessName"}
              label={"Business Name"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputText
              field={"TradingName"}
              label={"Trading Name"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputMask
              inputStyle={{ width: 150 }}
              field={"Abn"}
              label={"ABN"}
              mask={"99 999 999 999"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputText
              field={"WebAddress"}
              label={"Web Address"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputTextarea
              rows={3}
              field={"Address"}
              label={"Address"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputText
              field={"Suburb"}
              label={"Suburb"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputText
              inputStyle={{ width: 150 }}
              field={"State"}
              label={"State"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          <div className="p-col-12">
            <FieldInputText
              inputStyle={{ width: 70 }}
              field={"PostCode"}
              label={"Post Code"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
          {formName === "AnnualReturn" && (
            <div className="p-col-12">
              <FieldCheckbox
                inputStyle={{ width: 70 }}
                label={
                  "No relevant convictions to report for any registered lobbyists."
                }
                showAsTextOnly={showAsTextOnly}
                checked={!!this.props.LobbyistsNoConvictions}
                disabled={!canSave || !!this.props.LobbyistsYesConvictions}
                onChange={e => {
                  const checked = (typeof e === 'boolean') ? e : (e && typeof e.checked !== 'undefined' ? e.checked : (e && e.target ? e.target.checked : false));
                  // notify parent to update form state
                  if (this.props.onPropChange) {
                    this.props.onPropChange("LobbyistsNoConvictions", checked);
                    if (checked) {
                      this.props.onPropChange("LobbyistsYesConvictions", false);
                    }
                  }
                }}
              />
            </div>
          )}
          {formName === "AnnualReturn" && (
            <div className="p-col-12">
              <FieldCheckbox
                inputStyle={{ width: 70 }}
                label={
                  "Relevant convictions to report for registered lobbyists."
                }
                showAsTextOnly={showAsTextOnly}
                checked={!!this.props.LobbyistsYesConvictions}
                disabled={!canSave || !!this.props.LobbyistsNoConvictions}
                onChange={e => {
                  const checked = (typeof e === 'boolean') ? e : (e && typeof e.checked !== 'undefined' ? e.checked : (e && e.target ? e.target.checked : false));
                  if (this.props.onPropChange) {
                    this.props.onPropChange("LobbyistsYesConvictions", checked);
                    if (checked) {
                      this.props.onPropChange("LobbyistsNoConvictions", false);
                    }
                  }
                }}
              />
              <div className={`p-col-12 convictions-box ${this.props.LobbyistsYesConvictions ? 'convictions-box--active' : ''}`}>
                <div className="p-grid">
                  <div className="p-col-12">
                    <FieldInputText
                      field={"LobbyistsConvictionDetails"}
                      label={"Conviction Details"}
                      validationRules={validationRules}
                      disabled={!this.props.LobbyistsYesConvictions || !canSave}
                    />
                  </div>
                </div>
              </div>

            </div>
          )}
        </div>
      </Card>
    );
  }
}

export default CompanyDetails;



// WEBPACK FOOTER //
// ./src/components/lobbyist/company-details.js